import { authAxios } from '@/common/axios';

export default {
  search: async function (request) {
    return await authAxios.get('/api/employee/searchContacts', { params: request });
  },
};
